import {
  AvailableSeason,
  ScheduleModel
} from '@maxpreps/apiserviceclients/apiModels';
import { FetchResponse } from '@maxpreps/apiserviceclients/fetchResponse';
import useRequestContext from '@maxpreps/shared/contexts/RequestContext';
import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import { useIsMobile } from '@maxpreps/shared/hooks/useIsScreenSize';
import { IConfigurableLink } from '@maxpreps/shared/models/configurableLink';
import { useEffect, useState } from 'react';
import getCSRRewriteAttributes from '../utils/getCSRRewriteAttributes';
import { getTeamUrl } from './../utils/navigation';
import { Page } from './../utils/pages';

export const useSeasonPickerItems = (
  fetchFn:
    | ((
        teamId: string,
        ssid: string
      ) => Promise<FetchResponse<AvailableSeason[]>>)
    | undefined,
  pageKey: Page.Roster | Page.Schedule
): IConfigurableLink[] => {
  const teamContext = useTeamContext();
  const isMobile = useIsMobile();
  const { appType } = useRequestContext();

  const { teamSeasonPickerData, data, sportData } = teamContext;
  const { teamId, allSeasonId, sportSeasonId } = data;
  const { scheduleModel: scheduleModelKey } = sportData as never as {
    scheduleModel: keyof ScheduleModel;
  };

  const [previousSeasons, setPreviousSeasons] = useState<
    AvailableSeason[] | undefined
  >();

  useEffect(() => {
    if (!fetchFn) return;

    (async () => {
      const [data] = await fetchFn(teamId, sportSeasonId);
      if (data) setPreviousSeasons(data);
    })();
  }, [fetchFn, sportSeasonId, teamId]);

  return (
    previousSeasons?.map(x => {
      const sportSeason = teamSeasonPickerData.find(
        ss => ss.sportSeasonId === x.sportSeasonId
      );
      const anchorAttrs = getCSRRewriteAttributes(
        getTeamUrl(pageKey, sportSeason?.canonicalUrl ?? ''),
        teamId,
        x.sportSeasonId,
        allSeasonId,
        appType,
        undefined,
        ScheduleModel[scheduleModelKey]
      );

      return {
        text: isMobile ? x.year : `20${x.year}`,
        as: 'a',
        asOptions: anchorAttrs
      } as IConfigurableLink;
    }) ?? []
  );
};
